import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { TTCLID_MAX_AGE } from './constants';
import { TikTokClickIdentifiers } from './types';

export const useTikTokClickIdentifiers = (): TikTokClickIdentifiers => {
	const [cookies, setCookie] = useCookies(['ttclid', '_ttp']);
	const searchParams = useSearchParams();
	const ttclidFromUrl = searchParams?.get('ttclid') ?? undefined;

	useEffect(() => {
		if (ttclidFromUrl && ttclidFromUrl !== cookies.ttclid) {
			setCookie('ttclid', ttclidFromUrl, {
				path: '/',
				maxAge: TTCLID_MAX_AGE,
			});
		}
	}, [ttclidFromUrl, cookies.ttclid, setCookie]);

	return {
		ttclid: cookies.ttclid || ttclidFromUrl,
		ttp: cookies._ttp,
	};
};
